import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入主页组件
import Home from '../components/Home.vue'
// 导入主页首页组件
import Welcome from '../components/Index.vue'

// 导入公司介绍组件
import Company from '../components/eim/Company.vue'

// 导入业务范围组件
import Work from '../components/eim/Work.vue'

// 导入线上案例组件
import Online from '../components/eim/Online.vue'

// 导入线上案例h5组件
import H5 from '../components/eim/online/H5.vue'

// 导入线上案例推文组件
import Article from '../components/eim/online/Article.vue'

// 导入线上案例海报组件
import Poster from '../components/eim/online/Poster.vue'

// 导入线下案例组件
import Underline from '../components/eim/Underline.vue'

// 导入关于我们组件
import About from '../components/eim/About.vue'

// 导入加入我们组件
import Join from '../components/eim/Join.vue'

// 导入人才招聘组件
import Recruits from '../components/eim/join/Recruits.vue'

// 导入公司福利组件
import Welfare from '../components/eim/join/Welfare.vue'

// 导入办公环境组件
import Environment from '../components/eim/join/Environment.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: 'welcome',
    children: [
      {
        path: 'welcome',
        name: 'welcome',
        component: Welcome
      },
      {
        path: 'company',
        name: 'company',
        component: Company
      },
      {
        path: 'work',
        name: 'work',
        component: Work
      },
      {
        path: 'online',
        name: 'online',
        component: Online,
        redirect: 'online/H5',
        children: [
          {
            path: 'H5',
            name: 'H5',
            component: H5
          },
          {
            path: 'Article',
            name: 'Article',
            component: Article
          },
          {
            path: 'Poster',
            name: 'Poster',
            component: Poster
          }
        ]
      },
      {
        path: 'underline',
        name: 'underline',
        component: Underline
      },
      {
        path: 'about',
        name: 'about',
        component: About
      },
      {
        path: 'join',
        name: 'join',
        component: Join,
        redirect: 'join/Recruits',
        children: [
          {
            path: 'Recruits',
            name: 'Recruits',
            component: Recruits
          },
          {
            path: 'Welfare',
            name: 'Welfare',
            component: Welfare
          },
          {
            path: 'Environment',
            name: 'Environment',
            component: Environment
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

export default router
